import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AlphaPropertiesActionType, AlphaPropertiesStoreElement } from './AlphaPropertiesReducer.types';

// @ts-ignore
export const initialState: AlphaPropertiesStoreElement = Immutable.fromJS({
  color: '',
  errorcolor: [],
  name: '',
  errorname: [],
  tags: Immutable.List<any>(),
  errortags: [],
  category: '',
  errorcategory: [],
  osmosisPoints: undefined,
  errorosmosisPoints: [],
  regular: { description: '', error: [] },
  tagsOptions: Immutable.List<Immutable.Map<string, any>>(),
  hasUpdatedProperties: false,
  shouldScrollToAlphaProperties: false,
  combo: { description: '', error: [] },
  selection: { description: '', error: [] },
  showErrors: false,
  shouldSubmit: false,
  shouldCheck: false,
  fieldOnFocus: null,
});

const AlphaPropertiesReducer = handleActions<any>(
  {
    SET_TAGS_OPTIONS: (state: AlphaPropertiesStoreElement, action: AlphaPropertiesActionType) =>
      state.set('tagsOptions', Immutable.fromJS(action.payload.data)),
    SET_ALPHA_PROPERTIES_DATA: (state: AlphaPropertiesStoreElement, action: AlphaPropertiesActionType) =>
      state.merge(Immutable.fromJS(action.payload.data)),
    SET_ALPHA_PROPERTIES_DATA_ERRORS: (state: AlphaPropertiesStoreElement, action: AlphaPropertiesActionType) =>
      state.mergeDeep(Immutable.fromJS(action.payload.data)),
    CLEAR_SCROLL_TO_ALPHA_PROPERTIES: (state: AlphaPropertiesStoreElement) => state.set('shouldScrollToAlphaProperties', false),
    CLEAR_ALPHA_PROPERTIES: () => initialState,
    TOGGLE_FUNCTIONS_PROPERTY: (state: AlphaPropertiesStoreElement, action: AlphaPropertiesActionType) =>
      state.set(action.payload.property, action.payload.value),
    SET_ALPHA_PROPERTIES_ERROR: (state: AlphaPropertiesStoreElement) => state.set('showErrors', true),
    SET_FIELD_ON_FOCUS: (state: AlphaPropertiesStoreElement, action: AlphaPropertiesActionType) =>
      state.set('fieldOnFocus', action.payload),
    HAS_UPDATED_PROPERTIES: (state: AlphaPropertiesStoreElement) => state.set('hasUpdatedProperties', true),
    RESET_PROPERTIES: (state: AlphaPropertiesStoreElement) => state.set('hasUpdatedProperties', false),
    RESPONSE_UPDATE_ALPHA_PROPERTIES_SIMULATION: (state: AlphaPropertiesStoreElement) => state.set('hasUpdatedProperties', false),
    RESPONSE_UPDATE_ALPHA: (state: AlphaPropertiesStoreElement) => state.set('hasUpdatedProperties', false),
    SET_ALPHA_DETAIL_ASYNC: (state: AlphaPropertiesStoreElement, action: any) => {
      const osmosisPoints = action.payload.osmosisPoints;
      return state.set('osmosisPoints', osmosisPoints === null ? undefined : osmosisPoints);
    },
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default AlphaPropertiesReducer;
